// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const FilterLock = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 19}
    height={size ?? 19}
    fill="none"
    viewBox="0 0 19 19"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.5 4A2.5 2.5 0 0 1 12 6.5V9h1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h1V6.5A2.5 2.5 0 0 1 9.5 4m0 1A1.5 1.5 0 0 0 8 6.5V9h3V6.5A1.5 1.5 0 0 0 9.5 5"
    />
  </svg>
);
const ForwardRef = forwardRef(FilterLock);
export default ForwardRef;
